import { ViewMode } from '@efdigital/ll-addon-codemirror';
import type { QuizTotal } from '@efdigital/ll-addon-data';
import { MarkdownEditorWithImagePicker } from '@efdigital/ll-admin-v2/components/markdown-editor-with-image-picker';
import { SidebarAll } from '@efdigital/ll-admin-v2/lib/markdown-toolbar';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    total: QuizTotal;
  };
}

export class EditQuizTotalFeedback extends Component<Signature> {
  setMarkdown = (markdown: string) => {
    this.args.total.response.markdown = markdown;
  };

  <template>
    <div class="card-body">
      <div class="mb-3">
        <label class="form-label">Content</label>
        <MarkdownEditorWithImagePicker
          @markdown={{@total.response.markdown}}
          @toolbar={{SidebarAll}}
          @mode={{ViewMode.EditorOnly}}
          @onUpdate={{this.setMarkdown}}
          @requiredSize="email-image"
        >
          <:preview as |markdown|>
            <pre>{{markdown}}</pre>
          </:preview>
        </MarkdownEditorWithImagePicker>
      </div>
    </div>
  </template>
}
